module.exports = __webpack_public_path__ + "img/logo-white.cdf16160.svg";